import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AriOSMarketing } from './pages/AriOSMarketing';
import { Conditions } from './pages/Conditions';
import { Pricing } from './pages/Pricing';
export function AppRouter() {
  return <BrowserRouter data-id="element-27" data-mp="sqwn39jg2oec">
      <Routes data-id="element-28" data-mp="wukw7wnq5s1p">
        <Route path="/" element={<AriOSMarketing data-id="element-30" data-mp="wtj8ospivd33" />} data-id="element-29" data-mp="wucf1skkk0kp" />
        <Route path="/pricing" element={<Pricing data-id="element-32" data-mp="iutb7bysjbe7" />} data-id="element-31" data-mp="wsrosf5af3sn" />
        <Route path="/conditions" element={<Conditions data-id="element-34" data-mp="it8hfokavwhe" />} data-id="element-33" data-mp="iujukezmygl6" />
      </Routes>
    </BrowserRouter>;
}